'use strict'
const crossChainDispatcherAbi = require('./CrossChainDispatcher.json')
const debtTokenAbi = require('./DebtToken.json')
const depositTokenAbi = require('./DepositToken.json')
const feeProviderAbi = require('./FeeProvider.json')
const merkleV2Abi = require('./MerkleV2Abi.json')
const poolAbi = require('./Pool.json')
const poolRegistryAbi = require('./PoolRegistry.json')
const quoterAbi = require('./Quoter.json')
const rewardsDistributorAbi = require('./RewardsDistributor.json')
const swapperAbi = require('./Swapper.json')
const syntheticTokenAbi = require('./SyntheticToken.json')

module.exports = {
  crossChainDispatcherAbi,
  debtTokenAbi,
  depositTokenAbi,
  feeProviderAbi,
  merkleV2Abi,
  poolAbi,
  poolRegistryAbi,
  quoterAbi,
  rewardsDistributorAbi,
  swapperAbi,
  syntheticTokenAbi
}
